<ng-container *ngIf="riderContactProfiles.length === 1; else multiplePhoneNumbers">
  <small>Phone Number</small>
  <p id="riderPhoneNumber-text-value" data-private>
    {{ formatPhoneNumber(riderContactProfiles[0].phoneNumber) }}
  </p>
</ng-container>
<ng-template #multiplePhoneNumbers>
  <mat-form-field appearance="outline" class="phone-field" subscriptSizing="dynamic" required>
    <mat-label>Phone Number</mat-label>
    <mat-select
      id="riderPhoneNumber-select-phoneNumberSelection"
      [value]="currentPhoneNumberSelection"
      (selectionChange)="handlePhoneNumberSelected($event)"
      data-private
    >
      <mat-option
        *ngFor="let riderContactProfile of riderContactProfiles"
        id="riderPhoneNumber-option-{{ riderContactProfile.phoneNumber }}"
        [value]="riderContactProfile.phoneNumber"
      >
        {{ formatPhoneNumber(riderContactProfile.phoneNumber, riderContactProfile.organizationCode) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>
